import axios from "./axios";

interface GetAllArgs {
  practitionerId: string;
  scheduleId?: string;
  status?: string;
}
const getAllFiltered = async (params: GetAllArgs) => {
  const searchParams = new URLSearchParams((params as unknown) as Record<string, string>);
  const { data } = await axios.get(`/slot?${searchParams.toString()}`);
  return data;
};

const getById = async (slotId: string) => {
  const { data } = await axios.get(`/slot/${slotId}`);
  return data;
};

const getAll = async () => {
  const { data } = await axios.get(`/slot`);
  return data;
};

export const SlotsApi = { getAllFiltered, getById, getAll };
